import { render } from "./tree-base.vue?vue&type=template&id=3ff74cfa"
import script from "./tree-base.vue?vue&type=script&lang=js"
export * from "./tree-base.vue?vue&type=script&lang=js"

import "./tree-base.vue?vue&type=style&index=0&id=3ff74cfa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__